// UX S2: a popover menu (top layer, so table overflow can't clip it) placed under its opener, right edges aligned,
// kept inside the viewport; above the opener when there is no room below.
export function placePopover(popover: HTMLElement, anchor: HTMLElement, align: 'start' | 'end' = 'end'): void {
  const gap = 4
  const box = anchor.getBoundingClientRect()
  const width = popover.offsetWidth
  const height = popover.offsetHeight
  const left = align === 'end' ? box.right - width : box.left
  const below = box.bottom + gap
  const top = below + height > window.innerHeight && box.top - gap - height > 0 ? box.top - gap - height : below
  popover.style.left = `${Math.max(gap, Math.min(left, window.innerWidth - width - gap))}px`
  popover.style.top = `${Math.max(gap, top)}px`
}
